const hexToArrayBuffer = (hex) => {
  const bytes = new Uint8Array(hex.length / 2);
  for (let i = 0; i < bytes.length; i++) {
    bytes[i] = parseInt(hex.substr(i * 2, 2), 16);
  }
  return bytes.buffer;
};

const arrayBufferToBase64 = (buffer) => {
  let binary = "";
  const bytes = new Uint8Array(buffer);
  const chunkSize = 0x8000; // avoid call stack limits

  for (let i = 0; i < bytes.length; i += chunkSize) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize));
  }

  return btoa(binary);
};

export const fetchServerTimeAndNonce = async (baseUrl) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Basic ${btoa(
      `${process.env.REACT_APP_USERNAME}:${process.env.REACT_APP_PASSWORD}`,
    )}`,
  };
  const res = await fetch(`${baseUrl}/server-time-and-nonce`, {
    method: "GET",
    headers,
  });
  if (!res.ok) {
    throw new Error(`Failed to fetch server time/nonce: ${res.status}`);
  }
  return res.json();
};

export const encryptCredentials = async (payload) => {
  const credentialSecretKey = process.env.REACT_APP_CREDENTIAL_SECRET_KEY;
  const keyBuffer = hexToArrayBuffer(credentialSecretKey);

  const credentialIv = process.env.REACT_APP_CREDENTIAL_IV;
  const iv = new Uint8Array(hexToArrayBuffer(credentialIv)).slice(0, 16);

  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    keyBuffer,
    { name: "AES-CBC" },
    false,
    ["encrypt"],
  );

  const encoded = new TextEncoder().encode(JSON.stringify(payload));

  const encryptedBuffer = await crypto.subtle.encrypt(
    { name: "AES-CBC", iv },
    cryptoKey,
    encoded,
  );

  return arrayBufferToBase64(encryptedBuffer);
};
